import {
  FETCH_VIDEO_EARNINGS_REQUEST,
  FETCH_VIDEO_EARNINGS_SUCCESS,
  FETCH_VIDEO_EARNINGS_FAILURE,
  FETCH_TIP_EARNINGS_REQUEST,
  FETCH_TIP_EARNINGS_SUCCESS,
  FETCH_TIP_EARNINGS_FAILURE,
  FETCH_SUBS_EARNINGS_REQUEST,
  FETCH_SUBS_EARNINGS_SUCCESS,
  FETCH_SUBS_EARNINGS_FAILURE,
  FETCH_PAID_EARNINGS_SUCCESS,
  FETCH_LIVESTREAM_EARNINGS_SUCCESS,
} from "../actions/ActionConstant";

const initialState = {
  video: null,
  tips: null,
  subs: null,
  posts: null,
  live_streams: null,
  loading: false,
  error: null,
};

export default function CreatorEarningsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VIDEO_EARNINGS_REQUEST:
      return { ...state, loading: true };

    case FETCH_VIDEO_EARNINGS_SUCCESS:
      return { ...state, loading: false, video: action.payload };

    case FETCH_VIDEO_EARNINGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_TIP_EARNINGS_REQUEST:
      return { ...state, loading: true };

    case FETCH_TIP_EARNINGS_SUCCESS:
      return { ...state, loading: false, tips: action.payload };

    case FETCH_TIP_EARNINGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_SUBS_EARNINGS_REQUEST:
      return { ...state, loading: true };

    case FETCH_SUBS_EARNINGS_SUCCESS:
      return { ...state, loading: false, subs: action.payload };

    case FETCH_SUBS_EARNINGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_PAID_EARNINGS_SUCCESS:
      return { ...state, loading: false, posts: action.payload };

    case FETCH_LIVESTREAM_EARNINGS_SUCCESS:
      return { ...state, loading: false, live_streams: action.payload };

    default:
      return state;
  }
}
